import React from 'react'
import { Modal } from '@/components/Modal'
import { Button } from '@/components/Buttons/Button'
import { useTranslation } from '@/localization/useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faEnvelope, faTv } from '@fortawesome/free-solid-svg-icons'

import classes from '../authFeedbackModal.module.scss'

const ICONS = {
  'success-reset-password': faEnvelope,
  'success-change-password': faCircleCheck,
  'success-pair': faTv,
  'success-pair-relogin': faTv,
} as const

const MESSAGES = {
  'success-reset-password': {
    icon: 'success-reset-password',
    title: 'Your request has been submitted',
    body: 'We have sent you an email with instructions to reset your password.'
  },
  'success-change-password': {
    icon: 'success-change-password',
    title: 'All set!',
    body: 'Please login with your new password.'
  },
  'success-pair': {
    icon: 'success-pair',
    title: 'All set!',
    body: 'Your device has been successfully paired.'
  },
  'success-pair-relogin': {
    icon: 'success-pair-relogin',
    title: 'All set!',
    body: 'Your device has been successfully paired. Please log in again to keep using the web.'
  }
} as const

interface AuthSuccessModalProps {
  isVisible: boolean
  type: keyof typeof MESSAGES
  onDismiss?: () => void
}

export const AuthSuccessModal: React.FC<AuthSuccessModalProps> = (props) => {
  const { isVisible, type, onDismiss } = props
  const { t } = useTranslation()

  const icon = ICONS[type as keyof typeof ICONS]
  const message = MESSAGES[type as keyof typeof MESSAGES]

  return (
    <Modal isVisible={isVisible} size='medium'>
      <div className={classes.content}>
        <FontAwesomeIcon
          size="4x"
          icon={icon}
          color="var(--success-300)"
        />
        <div className={classes.text}>
          <h3>{t(message?.title)}</h3>
          <p>{t(message?.body)}</p>
        </div>
        <div className={classes.buttons}>
          <Button
            variant="primary"
            onClick={onDismiss}
            fullWidth
          >
            {t('Accept')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
